import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './emailForm.html?raw';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/Floating/Menu";
import "../../moreCore/UI/Container/ExpandableSectionTypes";
import Edit from '../../moreCore/UI/Edit/Edit';

import "../../moreCore/UI/Edit/HtmlEditor";
import HtmlEditor from '../../moreCore/UI/Edit/HtmlEditor';

import "./emailInput/emailInput";
import emailRecipientInput from './emailInput/emailInput';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';

import email_AttachmentSelector from './attachments/attachmentSelector';

import email_UploadedFilesDisplay from './attachments/uploadedFilesDisplay';
import "WidgetCollection/EMail/attachments/uploadedFilesDisplay"
import { StringHelpers, ToasterHelpers, TranslationHelpers } from "../../more/Helpers";
import EntityStore from '../../moreCore/Tools/EntityStore';
import { EmailEditorTypes } from "./emailTypes";
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';



class emailForm extends compose(_uiFrameMixin) {
    /*
    !!! Bitte emailFormStandalone verwenden auserhalb von emailHome... !!!
    */

    templateString: any = template;
    private inputMailSender: MdsLax<InstanceType<typeof emailRecipientInput>>;
    private emailSaveButton: HTMLButtonElement;
    private emailSendButton: HTMLButtonElement;
    //private emailLoadNew: HTMLButtonElement;
    private inputTO: MdsLax<InstanceType<typeof emailRecipientInput>>;
    private inputCC: MdsLax<InstanceType<typeof emailRecipientInput>>;
    private inputBCC: MdsLax<InstanceType<typeof emailRecipientInput>>;
    private inputSubject: MdsLax<InstanceType<typeof Edit>>;
    private bodyHtmlEditor: MdsLax<InstanceType<typeof HtmlEditor>>;

    private fileUploaderDisplayButtonRow: HTMLDivElement;
    //private reqMgr: RequestManager = new RequestManager();
    // updateWithMailSuggestions()
    //toast: Toaster;


    private formData: EmailEditorTypes.MailFormData;
    private _undirtyData: string;

    private readonly: boolean = false;

    private addressesStoreTO: MdsLax<InstanceType<typeof EntityStore<EmailEditorTypes.mailRecipient>>>;
    private addressesStoreCC: MdsLax<InstanceType<typeof EntityStore<EmailEditorTypes.mailRecipient>>>;
    private addressesStoreBCC: MdsLax<InstanceType<typeof EntityStore<EmailEditorTypes.mailRecipient>>>;
    private addressesStoreSender: MdsLax<InstanceType<typeof EntityStore<EmailEditorTypes.mailRecipient>>>;

    private saveButtonTextField: HTMLSpanElement;
    private sendButtonTextField: HTMLSpanElement;
    //fileUploaderText: HTMLSpanElement;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>>; //fuer popups

    private tabID: string = "";
    private tabName: string = "";
    private mailEntityId: string;

    private isBulkMail = false;

    private _isDirty: boolean = null; //wird fuer den Tabnamen verwendent.

    //wird fuer das check ob es aenderungen gibt verwendent -> checkIfValuesWereChanged()



    //private isStandalone: boolean = false;

    private flagIsVisible: boolean = true;


    private uploadedFilesDisplay: MdsLax<InstanceType<typeof email_UploadedFilesDisplay>>;
    private uploadDisplayContainer: HTMLElement;

    private mailFormEditorContainer: HTMLDivElement;
    private mailButtonContainer: HTMLDivElement;
    private mailSenderContainer: HTMLDivElement;

    private fileAttachmentContainer: HTMLDivElement;
    private attachmentsStore: MdsLax<InstanceType<typeof EntityStore<EmailEditorTypes.MailDataFile>>>
    private rawFileAttachments: Array<{ base64: string; fileID: string }> = [];
    private rawFileIDs: Array<string> = [];

    //default context
    private mailFormContext: EmailEditorTypes.mailFormContext = {
        //isProjectContext:false,
        //projectID: null,
        isHistoryContext: true,
    };

    public setMailFormContext(mailFormContext: EmailEditorTypes.mailFormContext) {
        this.mailFormContext = lang.clone(mailFormContext);

        this.attachmentSelector.setMailFormContext(this.mailFormContext);

        this.inputTO.setMailFormContext(this.mailFormContext);
        this.inputCC.setMailFormContext(this.mailFormContext);
        this.inputBCC.setMailFormContext(this.mailFormContext);
        this.inputMailSender.setMailFormContext(this.mailFormContext);

        this.serializeData();
    }

    private flagOnReloadSave = false; //flag ob bei einer neuen form, nach neu-erstellen des form widgets, die mail gesendet werden soll

    title: "email_mailForm_MainTitle";
    //#region init 4 data fetch
    /*private*/
    setup(mailEntityID: string, context: EmailEditorTypes.mailFormContext) { //laded die mailForm daten (wenn nicht neu) und setzt diese. die mailForm wird in der zwischenzeit mit einem blanken form geladen und dann einfach ueberschrieben

        this._loadingWasInitialized = true;

        if (context) this.setMailFormContext(context);

        if (mailEntityID) {

            this.setTitles("General_Loading");
            this._loadEntity(mailEntityID);


        } else {
            this.setTitles("email_mailFormStandalone_CreateNew");
            this.formData = this.getBlankMailData();
        }


    }
    //protected _onEmbedding() {
    //    this.hideNode(this.mailButtonContainer, this.isEmbeddedInTab);

    //    this._handleButtonStates();
    //}

    protected onShow() {
        if (this._uiFrameDlg) {
            this._uiFrameDlg.setSize("larger");
        }

        this.createDefaultButton("save", lang.hitch(this, this._onClick_SaveMail), false, null, "email_mailForm_saveButton");
        this.createDefaultButton("send", lang.hitch(this, this._onClick_SendMail), false);

        this.hideNode(this.mailButtonContainer, this.currentDisplayMode != "node");

        this._handleButtonStates();
    }

    private _onChange_InputTO() {
        let recipients = this.inputTO.getValue() as Array<EmailEditorTypes.mailRecipient>;

        this.addressesStoreTO.updateFromList(recipients, true);

    } private _onChange_InputCC() {
        let recipients = this.inputCC.getValue() as Array<EmailEditorTypes.mailRecipient>;

        this.addressesStoreCC.updateFromList(recipients, true);

    } private _onChange_InputBCC() {
        let recipients = this.inputBCC.getValue() as Array<EmailEditorTypes.mailRecipient>;

        this.addressesStoreBCC.updateFromList(recipients, true);

    }
    private _onChange_InputSender() {
        let recipients = this.inputMailSender.getValue() as Array<EmailEditorTypes.mailRecipient>;
        if (this.isBulkMail) this.addRecipients("to", recipients);

        this.addressesStoreSender.updateFromList(recipients, true);
    }

    private _onChange_AddressStore() {
        this.serializeData();
    }

    private _onSetup_AddressStore() {

    }

    private _onAdded_AttachmentStore(addedFile: EmailEditorTypes.MailDataFile) {
        //let list = this.attachmentsStore.getCurrentCompleteList();
        this.uploadedFilesDisplay.addFileButton(addedFile.filename, addedFile.guid);

    } private _onSetup_AttachmentStore() {


        let list = this.attachmentsStore.getCurrentCompleteList();
        for (let file of list) {
            this.uploadedFilesDisplay.addFileButton(file.filename, file.guid);
        }

    }
    private _onChange_AttachmentStore() {
        this.serializeData();
        //this.checkDirty();
    }
    public leaveOnlyValidBccAddresses(emailOriginLists: Array<string>, validMailAddresses: Array<string>) {

        if (emailOriginLists.indexOf("creator") != -1 || emailOriginLists.indexOf("sender") != -1) return;

        let inputs = [this.inputBCC];

        if (emailOriginLists.length == 1 && emailOriginLists.includes("bcc")) inputs.push(...[this.inputTO, this.inputCC]);
        
        inputs.forEach(i => {
            let newList = [];
            let addressList = i.getValue();

            addressList.forEach(v => {

                switch (typeof v) {
                    case "string":
                        if (validMailAddresses.indexOf(v) != -1) newList.push(v);
                        break;

                    case "object":
                        if (validMailAddresses.indexOf(v.mailaddress) != -1) newList.push(v);
                        break;
                }
            });
            i.setValue(null);
            i.setValue(newList);            
        })
    }

    addAddresses(addresses: Array<EmailEditorTypes.relatedMailAddress>) {
        let to: Array<EmailEditorTypes.mailRecipient> = [];
        let cc: Array<EmailEditorTypes.mailRecipient> = [];
        let bcc: Array<EmailEditorTypes.mailRecipient> = [];
        let sender: Array<EmailEditorTypes.mailRecipient> = [];


        if (addresses && addresses.length) {
            for (let entry of addresses) {


                if (entry.isTO) {
                    to.push({
                        entityID: entry.telecomID,
                        mailaddress: entry.mailaddress
                    });
                }

                if (entry.isCC) {
                    cc.push({
                        entityID: entry.telecomID,
                        mailaddress: entry.mailaddress
                    });
                }

                if (entry.isBCC) {
                    bcc.push({
                        entityID: entry.telecomID,
                        mailaddress: entry.mailaddress
                    });
                }

                if (entry.isSender) {
                    sender.push({
                        entityID: entry.telecomID,
                        mailaddress: entry.mailaddress
                    });
                }
            }

            this.addRecipients("to", to);
            this.addRecipients("cc", cc);
            this.addRecipients("bcc", bcc);
            this.addRecipients("sender", sender);

        }
    }

    loadRecipientAddress(type: "to" | "cc" | "bcc" | "sender", addressID: string) {

        if (!type || !addressID) return;

        switch (type) {
            case "to":
                this.StandbyStart(this.inputTO.domNode, "loadrecipient-" + type);
                break;
            case "cc":
                this.StandbyStart(this.inputCC.domNode, "loadrecipient-" + type);
                break;
            case "bcc":
                this.StandbyStart(this.inputBCC.domNode, "loadrecipient-" + type);
                break;
            case "sender":
                this.StandbyStart(this.inputMailSender.domNode, "loadrecipient-" + type);
                break;

            default: return;
                break;
        }

        this.RequestManager.callfunction("Webtool_API_EmailTransmission__GetMailAddressOfAddress",
            {
                addressID: addressID,
                type: type,
                mailEntityId: this.mailEntityId,
                context: this.mailFormContext
            },
            lang.hitch(this, this._onLoadRecipientAddress, type),
            lang.hitch(this, this._onLoadRecipientAddressError, type));
    }

    private _onLoadRecipientAddress(type: "to" | "cc" | "bcc" | "sender", response: EmailEditorTypes.mailRecipient) {
        this.StandbyStop("loadrecipient-" + type);

        if (response) {
            this.addRecipients(type, [response]);
        }
    }
    private _onLoadRecipientAddressError(type: "to" | "cc" | "bcc" | "sender", error: more.requestErrorMessage) {
        this.StandbyStop("loadrecipient-" + type);
    }

    addRecipients(type: "to" | "cc" | "bcc" | "sender", recipients: Array<EmailEditorTypes.mailRecipient>) {
        let result: Array<EmailEditorTypes.relatedMailAddress> = [];

        switch (type) {
            case "to":
                this.addressesStoreTO.addEntries(recipients);
                this.inputTO.addRecipients(recipients, true);
                break;

               
            case "cc":
                this.addressesStoreCC.addEntries(recipients);
                this.inputCC.addRecipients(recipients, true);
                break;


            case "bcc":
                this.addressesStoreBCC.addEntries(recipients);
                this.inputBCC.addRecipients(recipients, true);
                break;


            case "sender":
                this.addressesStoreSender.addEntries(recipients);
                this.inputMailSender.addRecipients(recipients, true);
                break;

        }

        //this.addressesStore.updateFromList(result);
    }

    private loadingCounter: number = 0;
    private _loadingWasInitialized = false;
    //private setLoading(isLoading:boolean){
    //    if (isLoading){
    //        this.loadingCounter++;
    //    }else{
    //        this.loadingCounter--;
    //    }
    //    if (this.loadingCounter > 0){
    //        this.loadingWasInitialized = true;
    //    }
    //    if ((this.loadingCounter == 0) || (this.loadingCounter < 0)){
    //        this.loadingWasInitialized = false;
    //    }
    //    let bError = false;
    //    if (this.loadingWasInitialized == true){
    //        if (typeof this.domNode != 'undefined'){
    //            let parentNode:HTMLElement;
    //            try{
    //                parentNode = this.getParent().domNode
    //            }catch{
    //                bError = true;
    //            }
    //            if (typeof parentNode == 'undefined'){
    //                bError = true;
    //            }
    //            if (bError == false){
    //                this.StandbyStart(parentNode);
    //            }
    //        }
    //        if (typeof this.mailFormEditorContainer != 'undefined'){
    //            this.mailFormEditorContainer.style.opacity = "0";
    //        }
    //        if (typeof this.mailButtonContainer != 'undefined'){
    //            this.mailButtonContainer.style.opacity  = "0";
    //        }
    //        if (typeof this.mailSenderContainer != 'undefined'){
    //            this.mailSenderContainer.style.opacity = "0";
    //        }
    //        try{
    //            let trl = document.querySelectorAll("[data-dojo-attach-point=\"tabRow\"]");
    //            for (let elem of trl as any as Array<HTMLDivElement>){
    //                elem.style.opacity = "0";
    //            }
    //        }catch{
    //            console.log("unable to hide tab row")
    //        }
    //    }
    //    if (this.loadingWasInitialized == false){
    //        this.StandbyStop();
    //        try{
    //            this.mailFormEditorContainer.style.opacity = "1";
    //        }catch{
    //            console.error("unable to un-hide mail editor!")
    //        }
    //        try{
    //            this.mailButtonContainer.style.opacity = "1";
    //        }catch{
    //            console.error("unable to un-hide mail buttons");
    //        }
    //        try{
    //            this.mailSenderContainer.style.opacity = "1";
    //        }catch{
    //            console.error("unable to un-hide sender input");
    //        }
    //        try {
    //            let trl = document.querySelectorAll("[data-dojo-attach-point=\"tabRow\"]");
    //            for (let elem of trl as any as Array<HTMLDivElement>) {
    //                elem.style.opacity = "1";
    //            }
    //        } catch {
    //            console.log("unable to un-hide tab row")
    //        }
    //        this.loadingCounter = 0;
    //    }
    //}

    //public setTabID(newVal: string) {
    //    this.tabID = newVal;
    //}
    //public getTabID() {
    //    if ((this.tabID === "") || (typeof this.tabID === 'undefined') || (this.tabID === null)) {
    //        return "";
    //    }
    //    return this.tabID;
    //}

    //public setTabName(newVal: string) {
    //    this.tabName = newVal;
    //}
    //public getTabName() {
    //    return this.tabName;
    //}

    //#region render
    //private renderForm() {

    //    let sender = "";
    //    let to: Array<EmailEditorTypes.mailRecipient> = [];
    //    let cc: Array<EmailEditorTypes.mailRecipient> = [];
    //    let bcc: Array<EmailEditorTypes.mailRecipient> = [];


    //    this.inputSubject.setValue(this.formData.subject);
    //    this.bodyHtmlEditor.setHtmlContent(this.formData.body);

    //    this.checkDirty();
    //}


    private _setSenderAsRecipient() {
        let currentSender = this.inputMailSender.getValue() as any;
        this.addRecipients("to", currentSender);
    }

    setToBulkmail(ccRecipients?: Array<EmailEditorTypes.mailRecipient>, bccRecipients?: Array<EmailEditorTypes.mailRecipient>) {
        this.isBulkMail = true;
        this.inputTO.setReadonly(true);
        this.addRecipients("cc", ccRecipients);
        this.addRecipients("bcc", bccRecipients);
    }

    private _serializeDataHandle: any = null;
    private serializeData(delay: number = 20) {
        if (this._serializeDataHandle) clearTimeout(this._serializeDataHandle);

        this._serializeDataHandle = setTimeout(lang.hitch(this, this._serializeData), delay);
    }

    private _serializeData() {
        if (!this.formData) this.formData = this.getBlankMailData();

        this.formData.ID = this.mailEntityId;

        this.formData.to = this.addressesStoreTO.getDiffData();
        this.formData.cc = this.addressesStoreCC.getDiffData();
        this.formData.bcc = this.addressesStoreBCC.getDiffData();
        this.formData.sender = this.addressesStoreSender.getDiffData();

        //let addresses = this.inputMailSender.getValue() as Array<EmailEditorTypes.mailRecipient>;
        //for (let addr of addresses) {
        //    this.formData.addresses.push({
        //        //addressID: addr.entityID,
        //        role: "sender",
        //        telecomID: addr.entityID,
        //        mailaddress: addr.mailaddress
        //    });
        //}

        //addresses = this.inputBCC.getValue() as Array<EmailEditorTypes.mailRecipient>;
        //for (let addr of addresses) {
        //    this.formData.addresses.push({
        //        //addressID: addr.entityID,
        //        role: "bcc",
        //        telecomID: addr.entityID,
        //        mailaddress: addr.mailaddress
        //    });
        //}

        //addresses = this.inputCC.getValue() as Array<EmailEditorTypes.mailRecipient>;
        //for (let addr of addresses) {
        //    this.formData.addresses.push({
        //        //addressID: addr.entityID,
        //        role: "cc",
        //        telecomID: addr.entityID,
        //        mailaddress: addr.mailaddress
        //    });
        //}
        //addresses = this.inputTO.getValue() as Array<EmailEditorTypes.mailRecipient>;
        //for (let addr of addresses) {
        //    this.formData.addresses.push({
        //        //addressID: addr.entityID,
        //        role: "to",
        //        telecomID: addr.entityID,
        //        mailaddress: addr.mailaddress
        //    });
        //}

        this.formData.body = this.bodyHtmlEditor.getHtmlContent();

        this.formData.mailContext = this.mailFormContext;
        this.formData.subject = this.inputSubject.getValue();

        this.formData.attachments = this.attachmentsStore.getDiffData();
        this.formData.rawFileAttachments = this.rawFileAttachments;


        if (this.mailEntityId) {
            this.setTitles(this.formData.subject ? this.translate("email_mailFormStandalone_EditMail") + " - " + this.formData.subject : "email_mailFormStandalone_EditMail");
        } else {
            this.setTitles(this.formData.subject ? this.translate("email_mailFormStandalone_CreateNew") + " - " + this.formData.subject : "email_mailFormStandalone_CreateNew");
        }

        this.checkValid();

        this.checkDirty();


        //console.trace(this.id + " serializeData", this.checkDirty(), this.formData);
    }

    public addContent(content: string) {
        this.bodyHtmlEditor.addHtmlContent(content);
    }

    //#region wasChanged?
    public checkDirty(): boolean {
        //check mit copy
        let dataWasChanged = false;

        let currentStrValue = null;
        if (this.formData) currentStrValue = JSON.stringify(this.formData);

        dataWasChanged = this._undirtyData != currentStrValue;

        if (dataWasChanged) {
            if (this._isDirty !== true) {
                this._isDirty = true;
                this.emit("dirty", true);
            }
        } else {
            if (this._isDirty === true) {
                this._isDirty = false;
                this.emit("dirty", false);
            }
        }

        this._handleButtonStates();

        return this._isDirty;
    }

    afterSendDisableSendButton() {
        let disabledClassList = ["w3-disabled", "disabled", "sL3"];
        for (let classElem of disabledClassList) {
            if (this.emailSendButton.classList.contains(classElem) == false) {
                //this.emailSendButton.classList.add(classElem);
            }
        }
        //this.emailSendButton.disabled = true;
    }

    //#region toogle buttons
    public _handleButtonStates() {

        let enableButtons = this.isDirty();

        if (this.readonly) enableButtons = false;

        if (enableButtons !== true && enableButtons !== false) {

        }

        this.disableNode(this.emailSendButton, !this._isValid);
        this.disableNode(this.emailSaveButton, this.readonly || !this.isDirty());

        this.enableButton("save", !this.readonly && this.isDirty());
        this.enableButton("send", this._isValid);
        //this.requestContextButtonEnable("save", enableButtons);
        //this.requestContextButtonEnable("send", enableButtons);

    }
    private _isValid: boolean = false;
    public checkValid(): boolean {

        let valid = true;
        if (this.formData) {
            valid = valid && !!this.formData.subject;
            valid = valid && !!this.inputTO.getValue()?.length;
            //valid = valid && !!this.formData.body;
        } else valid = false;

        this._isValid = valid;

        return valid;
    }

    //#region mark saved
    public isDirty(bForceCheck?: boolean): boolean {
        if (bForceCheck === true) this.checkDirty();
        return this._isDirty;
    }
    public resetDirty() {

        this._undirtyData = JSON.stringify(this.formData);
        //reseted den first Time check, da nach save, die form wie neu geoeffnet behandelt werden soll
        this.checkDirty();

        console.debug(this.id + " resetDirty", this._isDirty, this._undirtyData);


        if (typeof this.bodyHtmlEditor != 'undefined') {
            this.bodyHtmlEditor.markFormAsWasSaved();
        }
    }

    private attachmentSelector: MdsLax<InstanceType<typeof email_AttachmentSelector>> = null;// = new email_AttachmentSelector();
    //#region onClickFileUpload menu
    private clickFileAttachmentMenu(ev: MouseEvent) {
        this.attachmentSelector.openDlg(ev);

        this.attachmentSelector.setFileUploadRecord(this.uploadedFilesDisplay.getRecordState());

        //this.attachmentSelector.on("fileAdded", lang.hitch(this, this._onAttachmentSelected));
    }

    setSubject(newSubject: string) {
        if (this.readonly) {
            return;
        }

        this.inputSubject.setValue(newSubject);
    }
    async addAttachment(filename: string, fileID: string, filetype: 'file_email_attachment' | 'vt_file' | 'fileUploaderGUID' | "rawFile", rawFileB64?: string) {
        if (this.readonly) {
            return;
        }

        let readyFile: EmailEditorTypes.MailDataFile = null;
        let res: any = {};
        switch (filetype) {
            case 'file_email_attachment':
                // kann das file direkt hinzufuegen
                readyFile = { guid: fileID, filename: filename };
                break;
            case 'vt_file':
                // file attachment wird erstellt
                try {
                    res = await await this.attachmentSelector.APIconvertGeneralFile(fileID);
                    if (typeof res == 'boolean') {
                        throw "Error converting uploaded file!";
                    }
                } catch {
                    this.displayPopupMsg(this.translations["email_fileUpload_onError_convertingUploadedFile"], true, false);
                    console.error("error converting uploaded file");
                    return;
                }
                readyFile = { guid: res["fileID"], filename: res["fileName"] };//res["fileName"], res["fileID"]
                break;
            case 'fileUploaderGUID':
                // email file attachment wird aus datei im FS erstellt, am besten verwenden, wenn die datei vom Fileuploader frisch kommt
                try {
                    res = await await this.attachmentSelector.APIconvertUploadedFile({
                        guid: fileID,
                        filename: filename
                    });
                    if (typeof res == 'boolean') {
                        throw "Error converting uploaded file!";
                    }
                } catch (ex) {
                    console.error("error converting uploaded file", ex);
                    this.displayPopupMsg(this.translations["email_fileUpload_onError_convertingUploadedFile"], true, false, ex);

                    return;
                }
                readyFile = { filename: res["filename"], guid: res["id"] };//;res["filename"], res["ID"]
                if (typeof readyFile.guid == 'undefined') {
                    readyFile.guid = res["ID"];
                }

                //this.uploadedFilesDisplay.addFileButton(readyFile.filename, readyFile.guid);

                break;
            case 'rawFile':
                let rawFileID = StringHelpers.randomID(10);
                readyFile = { filename: filename, guid: rawFileID };
                this.rawFileIDs.push(rawFileID);
                this.rawFileAttachments.push({ base64: rawFileB64, fileID: rawFileID });
                break;
            default:
                //unreachable, oder?

                return;
                break;
        }

        if (readyFile) this.attachmentsStore.addEntry(readyFile);


    }

    private _onAttachmentRemoved(ID: string) {
        this.attachmentsStore.deleteEntry(ID);

        if (this.rawFileIDs.indexOf(ID) != -1) {
            let i = this.rawFileIDs.indexOf(ID);
            this.rawFileIDs.splice(i, 1);
            this.rawFileAttachments.splice(i, 1);
        }
    }
    private _onAttachmentSelected() {
        //this.upFilesMenuWidget.setRecordState({});
        let newRC: any = this.attachmentSelector.getFileUploadRecord();//undefined???
        this.uploadedFilesDisplay.setRecordState(newRC);

        //updated die file ids in der displayMailData
        this.fileUpload_updateElementsToDisplayList();
    }
    private _onFileUploadChangeForm() {
        try {
            this.attachmentSelector.setFileUploadRecord({});
        } catch {/* ist undefined, dann egal */ }
        let newRC: any = this.uploadedFilesDisplay.getRecordState();
        try {
            this.attachmentSelector.setFileUploadRecord(newRC);
        } catch {/* ist undefined, dann egal */ }

        //updated die file ids in der displayMailData
        this.fileUpload_updateElementsToDisplayList();
    }

    private fileUpload_updateElementsToDisplayList() {
        let newRC: any = this.uploadedFilesDisplay.getRecordState();
        //check ob dateien hinzu oder entfernt worden sind
        let newFileList: Array<EmailEditorTypes.MailDataFile> = [];
        for (let key in newRC) {
            if (newRC.hasOwnProperty(key)) {
                let curId = key;
                let val = newRC[key];
                let curFileName = val.filename;
                let fi: EmailEditorTypes.MailDataFile = {
                    guid: curId,
                    filename: curFileName,
                };
                newFileList.push(fi);
            }
        }
        let remFiles: Array<EmailEditorTypes.MailDataFile> = [];
        let newFiles: Array<EmailEditorTypes.MailDataFile> = [];
        let existingAttachments = this.attachmentsStore.getCurrentCompleteList();

        //wir gehen alle files in der display liste durch
        //und fuegen alle neuen elemente hinzu
        for (let newElem of newFileList) {
            let wasFoundInDisplayList = false;
            for (let chckElem of existingAttachments) {
                if (chckElem.guid == newElem.guid) {
                    wasFoundInDisplayList = true;
                    break;
                }
            }
            if (wasFoundInDisplayList == false) {
                //das element ist nicht in der liste, deshalb fuegen wir es hinzu
                newFiles.push(newElem);
            } else {
                //das element ist bereits in der liste, deshalb machen wir nichts
            }
        }
        //alle dateien die nicht im newRec sind, aber in der Display liste sind, wurden gelöscht.
        //deshalb löschen wir sie
        for (let chckElem of existingAttachments) {
            let wasFound = false;
            for (let elem of newFileList) {
                if (elem.guid == chckElem.guid) {
                    wasFound = true;
                    break;
                }
            }
            if (wasFound == false) {
                //das element war in der display liste aber nicht in der file upload bar -> wurde geloescht
                remFiles.push(chckElem);
                this.attachmentsStore.deleteEntry(chckElem);
            }
        }

        //updated die display liste
        this.attachmentsStore.addEntries(newFiles);
    }



    private _onClick_SaveMail(evt: MouseEvent) {
        evt.stopPropagation();

        this.saveAndSend(false);

    }
    private _onClick_SendMail(evt: MouseEvent) {
        evt.stopPropagation();

        if (document.activeElement != document.body) {
            //entfernt den focus vom geclickten button, da man ansonsten popups spamen könnte
            try {
                //@ts-expect-error
                document.activeElement.blur();
            } catch {/*elemnt hat kein blur()*/ }
        }
        this.dlg = new GenericDialog();
        let dlg = this.dlg;
        dlg.destroyOnClose = true;
        dlg.setSize("smaller");
        dlg._setTopCloseBtnAttr(false);
        dlg.closeOnEnter = false;
        dlg.closeOnEscape = false;
        dlg.Show(window.translations["email_mailForm_popup_sendMail_part1"] + "<br>" + window.translations["email_mailForm_popup_sendMail_part2"], window.translations["email_mailForm_popup_sendMail_header"], null, "far fa-question-circle w3-xxlarge", 'yesno', lang.hitch(this, (result: number) => {
            if (result == 2) {
                // wenn ja, sende mail
                this.saveAndSend(true);
            }
        }));
        //dlg.placeAt(this.alertPlacements)
    }

    private saveAndSend(bSendMail?: boolean) {
        if (this.readonly) return;
        if (!this.mailEntityId) {
            this.flagOnReloadSave = true;//does not work?
        }
        //this.StandbyStartWithText("saving");
        this.StandbyStart(null, "saving", "General_Saving");

        if (this.bodyHtmlEditor !== null) {
            this.bodyHtmlEditor.updateContentData();
        }

        let data = this.formData;
        //NOTE - weil email html im email clienten evtl. <pr><br></p> als zwei new lines anzeigt, hat jedoch keine auswirkung auf sceditor
        if (typeof data.body == 'string') {
            let bodyTxt = data.body;
            bodyTxt = bodyTxt.replace(/<p><br><\/p>/g, "<br>");
            bodyTxt = bodyTxt.replace(/<p>/g, "");
            bodyTxt = bodyTxt.replace(/<\/p>/g, "<br>");
            bodyTxt = bodyTxt.replace(/<br><br>$/, "");
            data.body = bodyTxt;
        }
        data["sendMail"] = bSendMail === true;

        this.RequestManager.post(
            window.appRoot + "EMail/UpdateMailData",
            {
                mailDataJson: JSON.stringify(data)
            },
            lang.hitch(this, this._onSaveMailResult, bSendMail),
            lang.hitch(this, this._onSaveMailError, bSendMail, "saveMail")
        );
        //this.RequestManager.callfunction(
        //    "Webtool_API_EmailTransmission__Save",
        //    data,
        //    lang.hitch(this, this._onSaveMailResult),
        //    lang.hitch(this, this._onGenericRequestError, "saveMail")
        //);

        //    if (res === true) {
        //        if (this.flagOnReloadSave){
        //            window["sendMailQueue"].push(this.formData);
        //        }
        //        this.resetDirty();
        //        this.displayPopupMsg(window.translations["email_mailForm_saveButton_onSuc"]);
        //    } else {
        //        this.displayPopupMsg(window.translations["email_mailForm_saveButton_onError_saving"], true);
        //    }

        //    this.emit("saveForm", {
        //        data: this.formData,
        //        tabID: this.getTabID(),
        //    });
        //    this.setLoading(false);
    }

    private _onSaveMailResult(bWasSent: boolean, result: EmailEditorTypes.EmailTransmissionEntity) {

        this.readonly = bWasSent;

        this.setEntity(result);

        this.StandbyStop("saving");

        this.showToast(bWasSent ? this.translate("email_mailForm_sendButton_onSuc") : this.translate("General__SaveSuccess"), toasterIcons.confirmCheck);

        if (bWasSent) this.emit("sent");
        this.emit("saved");

        this._handlePrivilegeStyles();
    }

    private _onSaveMailError(bWasSent: boolean, context: string, error: more.requestErrorMessage) {

        this.StandbyStop("saving");

        this.showToast((bWasSent ? this.translate("email_mailForm_onError_sendMail") : this.translate("General_SavingFailed")) + " - " + error.Message, toasterIcons.error);
    }


    public setEntity(entity: EmailEditorTypes.EmailTransmissionEntity) {
        this.mailEntityId = entity?.ID;

        let to: Array<EmailEditorTypes.mailRecipient> = [];
        let cc: Array<EmailEditorTypes.mailRecipient> = [];
        let bcc: Array<EmailEditorTypes.mailRecipient> = [];
        let sender: Array<EmailEditorTypes.mailRecipient> = [];

        let addresses = entity.EL_ht_addresses_communication_communication;

        this.inputTO.setValue(null, true);
        this.inputCC.setValue(null, true);
        this.inputBCC.setValue(null, true);
        this.inputMailSender.setValue(null, true);

        this.addressesStoreTO.empty();
        this.addressesStoreCC.empty();
        this.addressesStoreBCC.empty();
        this.addressesStoreSender.empty();
        this.attachmentsStore.empty();
        this.rawFileAttachments = [];
        this.rawFileIDs = [];

        if (addresses && addresses.length) {
            for (let entry of addresses) {

                let relatedAddress: EmailEditorTypes.mailRecipient = {
                    entityID: entry.ref_email_address?.ID,
                    mailaddress: entry.c_mail_address
                }

                if (entry.is_sender) {
                    sender.push(relatedAddress);
                }
                if (entry.is_to) {
                    to.push(relatedAddress);
                }
                if (entry.is_cc) {
                    cc.push(relatedAddress);
                }
                if (entry.is_bcc) {
                    bcc.push(relatedAddress);
                }
            }

            this.addRecipients("to", to);
            this.addRecipients("cc", cc);
            this.addRecipients("bcc", bcc);
            this.addRecipients("sender", sender);
        }

        this.addressesStoreTO.commit();
        this.addressesStoreCC.commit();
        this.addressesStoreBCC.commit();
        this.addressesStoreSender.commit();

        this.inputSubject.setValue(entity.mail_subject, true);
        this.bodyHtmlEditor.setHtmlContent(entity.html_mailtext, true);

        //setzt file uploads
        // die kommen aus der DB als normales Array, aber wir müssen intern einen Store benutzen zur Weiterverarbeitung
        let originalAttachments = entity.EL_ht_email_transmission_attachment_email_transmission
        let mailDataFiles: Array<EmailEditorTypes.MailDataFile> = [];
        //this.attachmentsStore.on("deleted", lang.hitch(this, this._onAdded_AttachmentStore));
        if (originalAttachments?.length) {
            for (let attachment of originalAttachments) {
                mailDataFiles.push({
                    filename: attachment.ref_vt_file.filename,
                    guid: attachment.ID
                })
            }
        }
        this.uploadedFilesDisplay.resetUploadDisplay();
        this.attachmentsStore.setup(mailDataFiles, "guid");



        this.serializeData();


        setTimeout(lang.hitch(this, this.resetDirty), 100); //um is dirty zu reseten

        this.emit("emailLoaded");
    }

    public getData() {
        return this.formData;
    }

    _onCloseRequest(): boolean { //wird aufgerufen wenn der tab geschlossen werden soll, return true/false um schliessen zu werlauben
        let tmp = this.showUnsavedPopup();
        return tmp; //sollte immer false sein
    }

    //#region unsaved popup
    private showUnsavedPopup(): boolean {
        if (this._isDirty === false) {
            return true;
        }
        if (document.activeElement != document.body) {
            //entfernt den focus vom geclickten button, da man ansonsten popups spamen könnte
            try {
                //@ts-expect-error
                document.activeElement.blur();
            } catch {/*elemnt hat kein blur()*/ }
        }
        //this._uiFrameDlg = new GenericDialog();
        let dlg = new GenericDialog();
        dlg.destroyOnClose = true;
        dlg.setSize("smaller");
        dlg._setTopCloseBtnAttr(false);
        dlg.closeOnEnter = false;
        dlg.closeOnEscape = false;
        dlg.Show(//"email_mailForm_popup_sendMail",
            "email_mailForm_popup_unsaved_Body_part1",
            "email_mailForm_MainTitle",
            null,//"email_mailForm_popup_sendMail_footnote",
            "fa fa-paper-plane w3-xlarge",
            'yesno',
            lang.hitch(this, (result: number) => {
                if (result >= 1) {
                    // wenn ja, schliessen
                    this.close();
                } else {

                }
            }));
        //dlg.placeAt(this.alertPlacements)
        return false; // return false um popup close vorerst unterbinden
    }

    //sollte aufgerufen werden, damit alle referenzen vor dem closeTab() sauber entfernt werden (fuer mailHome)
    public cleanAndCloseTab() {
        //this.emit("tabClosed", this.internalName);
        //this.close();
    }


    //#region onHide/Show
    //weil onHide der editor unloaded wird
    _onActivated() {
        this.flagIsVisible = true;
        try {
            this.bodyHtmlEditor.show();
        } catch { console.warn("failed to activate mailform editor"); }
    }

    _onHide() {
        this.flagIsVisible = false;
        try {
            this.bodyHtmlEditor.close();
        } catch { console.warn("failed to de-activate mailform editor"); }
    }

    //#region API stuff

    //#region send mail
    //private async sendEmail() {
    //    let id = this.formData.ID;
    //    let actionResult: any = true;
    //    try {
    //        actionResult = await this.APIsendEMail(id);
    //    } catch {
    //        actionResult = false;
    //    }
    //    if (actionResult === true) {
    //        this.displayPopupMsg(window.translations["email_mailForm_sendButton_onSuc"]);
    //        this.emit("updateMailList", null);
    //        this.afterSendDisableSendButton();
    //        return;
    //    }
    //    //error
    //    this.displayPopupMsg(window.translations["email_mailForm_onError_sendMail"], true);
    //}

    //#region get mail
    private async getMailSelectData() { // holt die email liste fuer mail Select aus dem SearchButton Menue
        let res = [] as any;
        try {
            res = await this.APIfetchMailSuggestions();
        } catch {
            this.displayPopupMsg(window.translations["email_mailSuggestion_onError"], true);
            return [];
        }
        if ((res === null) || (typeof res === 'undefined')) {
            return [];
        }
        return res;
    }

    //#region update mail

    //private updateMailDataxxxxxx(inputData: EmailEditorTypes.MailFormData) { // um mail daten aus der mailForm entweder zu updaten oder neu zu erstellen
    //    let newData: EmailEditorTypes.MailFormData = inputData;
    //    if ((typeof newData.ID === 'undefined') && (typeof (newData as any).id !== 'undefined')) {
    //        newData.ID = (newData as any).id;
    //    }
    //    if ((typeof newData.ID === 'undefined') || (newData.ID === "-1") || (newData.ID === null)) {
    //        //#region new mail
    //        try { // mailData is new
    //            let respond: any;
    //            respond = await this.APIaddNewMailData(newData);
    //            if (respond == null) {
    //                return false;
    //            }
    //            this.cleanAndCloseTab();
    //            this.emit("updateMailForm", respond.newID);
    //            this.emit("saved") //laded den mailpicker neu, da ein neues entry hinzugefuegt wurde
    //        } catch (er) {
    //            this.displayPopupMsg(window.translations["email_MailForm_onError_saveError"], true);
    //            return false;
    //        }
    //        return true;
    //    }
    //    //#region update mail
    //    try { // update bereits exestierende daten
    //        let wasSuccessful = await this.APIupdateMailData(newData);
    //        if (wasSuccessful == false) {
    //            return false;
    //        }
    //        this.emit("saved") //laded den mailpicker neu
    //        return true;
    //    } catch (er) {
    //        this.displayPopupMsg(window.translations["email_MailForm_onError_saveError"], true);
    //        return false;
    //    }
    //}

    private _loadEntity(id: string) { // um die display data zu laden

        this.StandbyStart(null, "_loadEntity");
        let data = {
            entityID: id
        };

        this.RequestManager.callfunction(
            "Webtool_API_EmailTransmission__GetMailData",
            data,
            lang.hitch(this, this._onLoadMailDataResult),
            lang.hitch(this, this._onGenericRequestError, "_loadEntity")
        );

    }

    private _onLoadMailDataResult(result: EmailEditorTypes.EmailTransmissionEntity) {
        this.StandbyStop("_loadEntity");
        //um sauber die daten zu setzen und ein render-form zu starten
        //und weil der scEditor sonst ummaspinnt oida

        this.setEntity(result);


    }

    //#region getBlankMailData
    private getBlankMailData(): EmailEditorTypes.MailFormData { //template fuer leeres email. hier koennte man auch in zukunft die sender mail einfuegen

        if (!this.mailEntityId) {
            this._loadAccountMail();
        }


        let blankData: EmailEditorTypes.MailFormData = {
            //addresses: null,
            to: null,
            cc: null,
            bcc: null,
            sender: null,
            attachments: null,
            body: "",
            ID: null,
            subject: "",
            //mailContext: null
        }

        return blankData;
    }

    //#region core api func

    //#region get acc mail
    private _loadAccountMail() {
        this.StandbyStart(this.inputMailSender.domNode, "senderaccount");

        this.RequestManager.callfunction(
            "Webtool_API_EmailTransmission__GetAccountSenderMail",
            null,
            lang.hitch(this, this._onLoadedAccountMail),
            lang.hitch(this, this._onGenericRequestError, this.translate("EmailForm_Error_GetSender"))
        );


    }

    private _onLoadedAccountMail(response: { senderAccountMail: string }) {

        //do something with the awaited result?
        if (!this.mailEntityId || (this.inputMailSender.getValue().length < 1)) { //soll nur hinzugefuegt werden, wenn mail neu ist oder nix steht
            let defaultSender: EmailEditorTypes.mailRecipient = {
                mailaddress: response.senderAccountMail,
                entityID: null
            }
            //let sender: EmailEditorTypes.
            this.inputMailSender.setValue([defaultSender]);
        }

        this.StandbyStop("senderaccount");
    }

    private _onGenericRequestError(title: string, error: more.requestErrorMessage) {
        this.StandbyStop();
        window.standbyManager?.removeAllStandbys();

        this.displayPopupMsg(title, true, false, error.Message);
    }


    //#region send mail
    private APIsendEMail(id: string) { // versendet die email
        let apiURL = window.appRoot + "EMail/SendMail" + "?id=" + String(id);
        return new Promise((resolve, reject) => {
            this.RequestManager.get(apiURL,
                (response) => {
                    resolve(true); // Resolve the promise w/ true
                },
                (error) => {
                    reject(false); // Reject the promise w/ false
                }
            );
        });
    }

    //#region fetchMailSuggestions
    public APIfetchMailSuggestions() { // holt die vorschlaege fuer das search button menue
        let postData = JSON.stringify(this.mailFormContext);
        postData = postData;
        let apiURL = window.appRoot + "EMail/GetMailSuggestions";
        return new Promise((resolve, reject) => {
            this.RequestManager.post(apiURL, { suggestionContext: postData },
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(null);
                }
            ),
                null
        });
    }

    //#region add new mail
    private APIaddNewMailData(newData: EmailEditorTypes.MailFormData) { //erstellt eine neue mail form
        let postData = JSON.stringify(newData);
        postData = postData;
        let apiURL = window.appRoot + "EMail/AddNewMailData";
        return new Promise((resolve, reject) => {
            this.RequestManager.post(apiURL, { mailDataJson: postData },
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(null);
                }
            ),
                null
        });
    }

    //#region update mail
    private APIupdateMailData(newData: EmailEditorTypes.MailFormData) { //updated bereits existierende mail form
        let postData = JSON.stringify(newData);
        postData = postData;
        let apiURL = window.appRoot + "EMail/UpdateMailData";
        return new Promise((resolve, reject) => {
            this.RequestManager.post(apiURL, { mailDataJson: postData },
                (response) => {
                    resolve(true);
                },
                (error) => {
                    reject(false);
                }
            ),
                null
        });
    }

    //#region fetch mail
    private _APIfetchMailData(entityID: string) { //holt eine mail form
        let apiURL = window.appRoot + "EMail/MailData" + "?id=" + String(entityID).replace(":", "$");
        return new Promise((resolve, reject) => {
            this.RequestManager.get(apiURL,
                (response) => {
                    let res = response as any;
                    if ((res === "{}") || (res === "") || (typeof res === 'undefined')) {
                        reject(null);
                    }
                    resolve(res);
                },
                (error) => {
                    reject(null);
                }
            );
        });
    }

    //#region popup msg
    public displayPopupMsg(title: string, isError?: boolean, isWarning?: boolean, message?: string) {

        let currentIconSelection = ToasterHelpers.ToasterIcons.info;
        let timeoutMS = 1000;
        if (isWarning === true) {
            console.warn(title);
            currentIconSelection = ToasterHelpers.ToasterIcons.warning;
            timeoutMS = 60000;
        }
        if (isError === true) {
            console.error(title);
            currentIconSelection = ToasterHelpers.ToasterIcons.error;
            timeoutMS = 60000;
        } else {
            console.info(title);
            timeoutMS = 8000;
        }
        ToasterHelpers.showToast({
            title: title,
            iconClass: currentIconSelection,
            ID: "emailErrorMsg",
            timeout: timeoutMS,
            showClose: true,
            message: message
        });
    }

    public reloadEditor() {
        try {
            this.bodyHtmlEditor.destroy();
            this.bodyHtmlEditor.SCEditor_reload();
        } catch {
            console.warn("unable to relaod sceditor");
        }
    }

    private _handlePrivilegeStyles() {

        this.hideNode(this.emailSaveButton, !this.hasFeature("Email_Editor", "SaveMail") || this.readonly)
        this.hideNode(this.emailSendButton, !this.hasFeature("Email_Editor", "SendMail") || this.readonly)

        if (this.readonly) {
            this.disableButton("send");
            this.disableButton("save");

            this.removeButton("save");
            this.removeButton("send");
        }

        this.inputTO.setReadonly(this.readonly);
        this.inputCC.setReadonly(this.readonly);
        this.inputBCC.setReadonly(this.readonly);

        this.disableNode(this.mailFormEditorContainer, this.readonly);
        this.disableNode(this.inputSubject, this.readonly);

        //feature check
        this.hideNode(this.fileAttachmentContainer, !this.hasFeature("Email_Editor", "Attachment"))
        this.disableNode(this.fileAttachmentContainer, this.readonly);
    }

    //#region postCreate
    postCreate() {
        this.useStandbyManager = true;
        super.postCreate.apply(this, arguments as any);

        //ctr+s hijack
        document.addEventListener("keydown", lang.hitch(this, (ev: KeyboardEvent) => {
            if (ev.ctrlKey && (ev.key === 's')) {
                if (this.flagIsVisible == true) {
                    try {
                        if (this.emailSaveButton.classList.contains("disabled") === false) {
                            ev.preventDefault();
                            this.saveAndSend(false);
                        }
                    } catch {
                        return;
                    }
                }
            }
        }));

        this.attachmentSelector = new email_AttachmentSelector();
        this.attachmentSelector.on("newFile", lang.hitch(this, this._onAttachmentSelected));
        this.attachmentSelector.on("removedFile", lang.hitch(this, this._onAttachmentRemoved));
        this.attachmentSelector.on("displayPopupMsg", lang.hitch(this, (ev: { msg: string, isError: boolean, isWarning: boolean }) => {
            this.displayPopupMsg(ev.msg, ev.isError, ev.isWarning);
        }));


        this.uploadedFilesDisplay = new email_UploadedFilesDisplay();
        this.uploadedFilesDisplay.placeAt(this.uploadDisplayContainer, "only");

        this.uploadedFilesDisplay.on("fileUploadChange", lang.hitch(this, this._onFileUploadChangeForm));
        this.uploadedFilesDisplay.on("removedFile", lang.hitch(this, this._onAttachmentRemoved));


        this.attachmentsStore = new EntityStore();
        this.attachmentsStore.keyAttribute = "guid";
        this.attachmentsStore.on("change", lang.hitch(this, this._onChange_AttachmentStore));
        this.attachmentsStore.on("added", lang.hitch(this, this._onAdded_AttachmentStore));
        this.attachmentsStore.on("dataset", lang.hitch(this, this._onSetup_AttachmentStore));

        this.addressesStoreSender = new EntityStore();
        this.addressesStoreSender.keyAttribute = "mailaddress";
        this.addressesStoreSender.on("change", lang.hitch(this, this._onChange_AddressStore));
        this.addressesStoreSender.on("dataset", lang.hitch(this, this._onSetup_AddressStore));


        this.addressesStoreTO = new EntityStore();
        this.addressesStoreTO.keyAttribute = "mailaddress";
        this.addressesStoreTO.on("change", lang.hitch(this, this._onChange_AddressStore));
        this.addressesStoreTO.on("dataset", lang.hitch(this, this._onSetup_AddressStore));

        this.addressesStoreCC = new EntityStore();
        this.addressesStoreCC.keyAttribute = "mailaddress";
        this.addressesStoreCC.on("change", lang.hitch(this, this._onChange_AddressStore));
        this.addressesStoreCC.on("dataset", lang.hitch(this, this._onSetup_AddressStore));

        this.addressesStoreBCC = new EntityStore();
        this.addressesStoreBCC.keyAttribute = "mailaddress";
        this.addressesStoreBCC.on("change", lang.hitch(this, this._onChange_AddressStore));
        this.addressesStoreBCC.on("dataset", lang.hitch(this, this._onSetup_AddressStore));

        // setzt translations fuer die Labels
        //this.inputMailSender.setLabel(TranslationHelpers.translate("email_mailForm_label_sender"));
        //this.inputTO.setLabel(TranslationHelpers.translate("email_mailForm_label_receiver"));
        //this.inputCC.setLabel(TranslationHelpers.translate("email_mailForm_label_CC"));
        //this.inputBCC.setLabel(TranslationHelpers.translate("email_mailForm_label_BCC"));
        //this.inputSubject.setLabel(TranslationHelpers.translate("email_mailForm_label_Subject"));
        //this.fileUploaderText.innerHTML = window.translations["email_mailForm_label_FileUpload"];
        // ende setzt translations

        //register event "valueChange" fuer alle text boxen
        this.inputMailSender.on("change", lang.hitch(this, this._onChange_InputSender));

        this.inputTO.on("change", lang.hitch(this, this._onChange_InputTO));

        this.inputCC.on("change", lang.hitch(this, this._onChange_InputCC));

        this.inputBCC.on("change", lang.hitch(this, this._onChange_InputBCC));

        this.inputSubject.on("change", lang.hitch(this, this.serializeData));

        this.bodyHtmlEditor.on("change", lang.hitch(this, this.serializeData));

        this._handleButtonStates();

        this.inputSubject.setPlaceholder(window.translations["email_mailForm_subject_hint"]);

        //#region emailSuggestion click

        //this.bodyHtmlEditor.on("popupWarning", lang.hitch(this, (warningMsg) => {
        //    this.displayPopupMsg(warningMsg, false, true);
        //}));


        this._handlePrivilegeStyles();

        this.bodyHtmlEditor.setShowTranslationButton(true);
    }


    startup(): void {
        super.startup.apply(this, arguments as any);
        //this.setStartupState("loading");

        if (this.formData) {

        }
        else if (!this._loadingWasInitialized) {
            this.setup(this.mailEntityId, this.mailFormContext);
        }
    }


}

export default mdsWidget(emailForm);
